export default function enableFormSubmit(form) {
  form.querySelector('[type="submit"]').removeAttribute('disabled');
}
